module.exports = __webpack_public_path__ + "img/bg-goModel.adb7e187.png";